import { Button, Dialog, Input, Select } from '@artosera/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import type { Langue } from '@artosera/shared';
import { useCreerCampagne } from '../../api/newsletter.js';
import { useShellContext } from '../shell/context.js';
import { ErreurNewsletter } from './ErreurNewsletter.js';
import { MODELES_CAMPAGNE, type ModeleCampagne } from './modeles.js';
import styles from './NewsletterPage.module.css';
export function NouvelleCampagneDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  const { t } = useTranslation(['regie', 'commun']);
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('regie:newsletter.nouvelle.titre')}
      closeLabel={t('commun:actions.fermer')}
    >
      {open ? <FormNouvelle /> : null}
    </Dialog>
  );
}
function FormNouvelle() {
  const { t, i18n } = useTranslation(['regie', 'commun']);
  const { galerieSlug } = useShellContext();
  const creer = useCreerCampagne(galerieSlug);
  const navigate = useNavigate();
  const [titre, setTitre] = useState('');
  const [langue, setLangue] = useState<Langue>(i18n.language.startsWith('en') ? 'en' : 'fr');
  const [modele, setModele] = useState<ModeleCampagne>('vierge');
  return (
    <form
      className={styles.formulaire}
      onSubmit={(e) => {
        e.preventDefault();
        const texte = (cle: string) =>
          t(`regie:newsletter.modeles.${modele}.${cle}`, { lng: langue });
        creer.mutate(
          {
            titre,
            sujet: modele === 'vierge' ? titre : texte('sujet'),
            langue,
            blocs: modele === 'vierge' ? [] : [{ type: 'texte', texte: texte('intro') }],
          },
          {
            onSuccess: ({ campagne }) => {
              void navigate(`/${galerieSlug}/newsletter/campagnes/${campagne.id}`);
            },
          },
        );
      }}
    >
      <label>
        {t('regie:newsletter.nouvelle.nom')}
        <Input
          required
          maxLength={120}
          value={titre}
          placeholder={t('regie:newsletter.nouvelle.nomExemple')}
          onChange={(e) => setTitre(e.target.value)}
        />
      </label>
      <p className={styles.aide}>{t('regie:newsletter.nouvelle.nomAide')}</p>
      <label htmlFor="langue-nouvelle">{t('regie:newsletter.campagne.langue')}</label>
      <Select
        id="langue-nouvelle"
        value={langue}
        options={[
          { value: 'fr', label: 'Français' },
          { value: 'en', label: 'English' },
        ]}
        onValueChange={(v) => setLangue(v as Langue)}
      />
      <fieldset className={styles.modeles}>
        <legend>{t('regie:newsletter.nouvelle.modele')}</legend>
        {MODELES_CAMPAGNE.map((m) => (
          <label className={styles.modele} key={m} data-choisi={modele === m ? 'oui' : undefined}>
            <input
              type="radio"
              name="modele-campagne"
              checked={modele === m}
              onChange={() => setModele(m)}
            />
            <span>
              <strong>{t(`regie:newsletter.modeles.${m}.nom`)}</strong>
              <span className={styles.aide}>{t(`regie:newsletter.modeles.${m}.description`)}</span>
            </span>
          </label>
        ))}
      </fieldset>
      <ErreurNewsletter erreur={creer.error} />
      <Button type="submit" disabled={creer.isPending || !titre.trim()}>
        {t('regie:newsletter.nouvelle.creer')}
      </Button>
    </form>
  );
}
